module.exports = __webpack_public_path__ + "static/media/get-recommendations-tabletPro-es.b736e25c.png";